import React, { Component } from 'react';
import { Badge, Divider, Icon, message, Popconfirm, Table } from 'antd';
import { Link } from 'react-router';
import {
  queryProjUpdStatus,
  querySetTaskCollect,
  querySetTaskUnCollect,
  queryTaskDiscard,
} from '@api/task';
import moment from 'moment';

class TableTask extends Component {
  constructor(props) {
    super(props);
    this.state = {
      data: [],
    };
  }

  componentWillMount() {}

  componentDidMount() {
    const { data } = this.props;
    this.setState({ data });
  }

  componentWillReceiveProps(nextProps) {
    const { data } = nextProps;
    if (data !== this.props.data) {
      this.setState({ data });
    }
  }

  getProjUpdStatus = (uuid, status) => {
    queryProjUpdStatus({
      uuid,
      status,
    }).then(res => {
      if (res.statusCode === 200) {
        message.success(res.message);
      } else {
        message.error(res.message);
      }
    });
  };

  setTaskCollect = record => {
    const { data } = this.state;
    querySetTaskCollect({ uuid: record.uuid }).then(res => {
      if (res.statusCode === 200) {
        message.success(res.message);
        record.collectFlag = true;
        this.setState({ data });
      } else {
        message.error(res.message);
      }
    });
  };

  setTaskUnCollect = record => {
    const { data } = this.state;

    querySetTaskUnCollect({ uuid: record.uuid }).then(res => {
      if (res.statusCode === 200) {
        message.success(res.message);
        record.collectFlag = false;
        this.setState({ data });
      } else {
        message.error(res.message);
      }
    });
  };

  columns = () => {
    let config = [
      {
        title: '',
        dataIndex: 'collectFlag',
        width: 30,
        render: (text, record) => {
          if (text) {
            return (
              <Icon
                type="heart"
                style={{
                  color: 'red',
                }}
                theme="filled"
                onClick={() => this.setTaskUnCollect(record)}
              />
            );
          }
          return <Icon type="heart" theme="outlined" onClick={() => this.setTaskCollect(record)} />;
        },
      },
      {
        title: '任务标题',
        dataIndex: 'name',
        key: 'name',
        render: (text, record) => {
          return <Link to={`/task/task_detail/${record.uuid}`}>{text}</Link>;
        },
      },
      {
        title: '任务分类',
        dataIndex: 'type',
        key: 'type',
        render: (text, record) => {
          switch (text) {
            case 0:
              return '绩效考核';
            case 1:
              return '政府申报';
            case 2:
              return '日常任务';
            default:
          }
        },
      },
      {
        title: '业务部门/标签/项目',
        dataIndex: 'workorgName',
        key: 'workorgName',
        render: (text, record) => {
          return (
            <div>
              <p>{text}</p>
              <p>
                {record.tags.map(item => {
                  return (
                    <span
                      key={item}
                      style={{
                        border: '1px solid #D3D3D3',
                        borderRadius: '5%',
                        marginRight: '5px',
                      }}
                    >
                      {item}
                    </span>
                  );
                })}
              </p>
              {this.props.type === 'receive' ? (
                <Link to={`/task/project_detail/${record.projectUuid}`}>{record.projectName}</Link>
              ) : (
                <Link to={`/task/project_detail_manage/${record.projectUuid}`}>
                  {record.projectName}
                </Link>
              )}
            </div>
          );
        },
      },
      {
        title: '相关人员',
        dataIndex: 'executives',
        key: 'executives',
        render: (text, record) => {
          return (
            <div>
              <p>
                <span style={{ color: '#D8D1CF' }}>执</span>
                {record.executives.map(item => {
                  return (
                    <span key={item.uuid} style={{ paddingLeft: '5px', paddingRight: '5px' }}>
                      {item.userName}
                    </span>
                  );
                })}
              </p>
              <p style={{ marginBottom: '0' }}>
                <span style={{ color: '#D8D1CF' }}>协</span>
                {record.assistants.map(item => {
                  return (
                    <span key={item.uuid} style={{ paddingLeft: '5px', paddingRight: '5px' }}>
                      {item.userName}
                    </span>
                  );
                })}
              </p>
            </div>
          );
        },
      },
      {
        title: '截止时间',
        dataIndex: 'endDate',
        key: 'endDate',
        render: (text, record) => {
          return <span>{text ? moment.unix(text / 1000).format('YYYY-MM-DD') : ''}</span>;
        },
      },
      {
        title: '完成时间',
        dataIndex: 'completionDate',
        key: 'completionDate',
        render: (text, record) => {
          let day = 0;
          if (record.completionDate && record.endDate) {
            day = Math.floor((record.completionDate - record.endDate) / 86400000);
          }

          const element =
            day > 0 ? (
              <span style={{ color: 'red', marginLeft: '10px' }}>逾期{day}天</span>
            ) : (
              <span style={{ color: 'green', marginLeft: '10px' }}>提前{Math.abs(day)}天</span>
            );
          return (
            <span>
              {text ? moment.unix(text / 1000).format('YYYY-MM-DD HH:mm:ss') : ''}
              {day ? element : ''}
            </span>
          );
        },
      },
      {
        title: '状态',
        dataIndex: 'status',
        render: (text, record) => {
          if (record.status === 1) {
            switch (record.fettle) {
              case 1:
                return <Badge color="red" text="已逾期" />;
              case 2:
                return <Badge color="blue" text="进行中" />;
              case 3:
                return <Badge color="yellow" text="未开始" />;
              default:
            }
          } else if (record.status === 2) {
            switch (record.fettle) {
              case 1:
                return <Badge color="red" text="未完成" />;
              case 2:
                return <Badge color="green" text="已完成" />;
              case 3:
                return <Badge color="gray" text="已废弃" />;
              default:
            }
          } else if (record.status === 0) {
            return <Badge color="yellow" text="待编辑" />;
          }
        },
      },
      {
        title: '操作',
        dataIndex: 'done',
        key: 'done',
        render: (text, record) => {
          switch (record.status) {
            case 0:
              return (
                <div>
                  <a onClick={() => this.toPageEdit(record)}>编辑</a>
                </div>
              );
            case 1:
              return (
                <div>
                  <a onClick={() => this.toPageEdit(record)}>编辑</a>
                  <Divider type="vertical" />
                  <Popconfirm
                    placement="leftTop"
                    title="确定废弃任务吗？"
                    onConfirm={() => this.handleDisTask(record.uuid)}
                    okText="确定"
                    cancelText="取消"
                  >
                    <a>废弃</a>
                  </Popconfirm>
                </div>
              );
            case 2:
              return <div />;
            default:
          }
        },
      },
    ];
    if (this.props.type === 'receive' || this.props.type2 === 'finish') {
      config = config.filter(item => item.key !== 'done');
    }
    if (this.props.type2 !== 'finish') {
      config = config.filter(item => item.key !== 'completionDate');
    }
    return config;
  };

  toPageEdit = record => {
    if (record.projectUuid) {
      this.props.router.push({
        pathname: `/task/project_task_edit/${record.uuid}`,
        query: {
          projectUuid: record.projectUuid,
          projectName: record.projectName,
          directoryUuid: record.directoryUuid,
          directoryName: record.directoryName,
        },
      });
    } else {
      this.props.router.push(`/task/task_edit/${record.uuid}`);
    }
  };

  // 废弃任务
  handleDisTask = uuid => {
    queryTaskDiscard({ uuid }).then(res => {
      if (res.statusCode === 200) {
        message.success(res.message);
        this.props.loadData();
      } else {
        message.error(res.message);
      }
    });
  };

  render() {
    const { data } = this.state;
    const { pagination, isLoading } = this.props;
    return (
      <Table
        size="small"
        rowKey="uuid"
        dataSource={data}
        loading={isLoading}
        pagination={pagination}
        columns={this.columns()}
        onChange={this.props.onChange}
      />
    );
  }
}

export default TableTask;



// WEBPACK FOOTER //
// ./src/components/task/spTask/TableTask.js